import { useClassGroups } from 'modules/arena/class-groups/useClassGroups';
import { StatTile } from 'shared/components/ui/StatTile';
import { ClassGroupRow } from 'modules/arena/class-groups/components/ClassGroupRow';
import { ClassGroupDetailPanel } from 'modules/arena/class-groups/components/ClassGroupDetailPanel';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { SkeletonListDetail, SkeletonStatGrid } from 'shared/components/ui/Skeleton';

export function ArenaClassGroupsPage() {
  const {
    groups,
    isLoading,
    error,
    selectedId,
    setSelectedId,
    selectedGroup,
    expandedSessionId,
    toggleExpandSession,
    togglePresence,
    saveAttendance,
    toggleGroupStatus,
  } = useClassGroups();

  const activeGroups = groups.filter((group) => group.status === 'ativa');
  const totalEnrolled = groups.reduce(
    (sum, group) => sum + group.students.filter((student) => student.status !== 'cancelada').length,
    0
  );
  const totalCapacity = groups.reduce((sum, group) => sum + group.capacity, 0);
  const availableSpots = totalCapacity - totalEnrolled;
  const occupancyRate = totalCapacity > 0 ? Math.round((totalEnrolled / totalCapacity) * 100) : 0;

  return (
    <div className="flex-1 p-6">
      <h1 className="font-heading text-xl font-bold text-ink">Aulas e Turmas</h1>
      <p className="text-sm text-ink-secondary">
        Turmas recorrentes, alunos matriculados e controle de presença por sessão.
      </p>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando turmas..."
        skeleton={
          <>
            <SkeletonStatGrid />
            <SkeletonListDetail lines={3} className="mt-6" />
          </>
        }
      >
          <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
            <StatTile label="Turmas ativas" value={String(activeGroups.length)} />
            <StatTile label="Alunos matriculados" value={String(totalEnrolled)} />
            <StatTile label="Vagas disponíveis" value={String(availableSpots)} />
            <StatTile label="Ocupação média" value={`${occupancyRate}%`} />
          </div>

          <div className="mt-6 grid gap-6 lg:grid-cols-[1.1fr_1fr]">
            <div className="flex flex-col gap-3">
              {groups.map((group) => (
                <ClassGroupRow
                  key={group.id}
                  group={group}
                  isSelected={group.id === selectedId}
                  onSelect={setSelectedId}
                />
              ))}
            </div>

            <div className="lg:sticky lg:top-6 lg:self-start">
              {selectedGroup ? (
                <ClassGroupDetailPanel
                  group={selectedGroup}
                  expandedSessionId={expandedSessionId}
                  onToggleExpandSession={toggleExpandSession}
                  onTogglePresence={togglePresence}
                  onSaveAttendance={saveAttendance}
                  onToggleGroupStatus={toggleGroupStatus}
                />
              ) : (
                <p className="text-sm text-ink-secondary">Selecione uma turma para ver os detalhes.</p>
              )}
            </div>
          </div>
      </AsyncSection>
    </div>
  );
}
